import type {Configs} from '@/api/configService';
import type {ServiceCenterOpeningHours} from '@/config/models';

const parseTimeFromAndTo = (from: string, to: string) => {
  const [hoursFrom, possibleMinutesFrom] = from.split(':');
  const [hoursTo, possibleMinutesTo] = to.split(':');

  const minutesFrom = possibleMinutesFrom ? `:${possibleMinutesFrom}` : '';
  const minutesTo = possibleMinutesTo ? `:${possibleMinutesTo}` : '';

  return {
    timeFrom: `${hoursFrom}${minutesFrom}`,
    timeUntil: `${hoursTo}${minutesTo}`,
  };
};

export const extractServiceCenterOpeningHours = (
  configServiceConfig: Configs | null
): ServiceCenterOpeningHours => {
  // We add a new object to the config
  // So that we can easily use the special openening hours in our own components
  // also we map the incoming config to our own format `from` vs `timeFrom`
  const serviceCenterOpeningHours: ServiceCenterOpeningHours = {
    defaultOpeningHours: undefined,
    specialOpeningHours: [],
  };

  // openingHours are optional so we need to check if they are present
  if (configServiceConfig?.headers?.[0]?.hotline?.openingHours) {
    serviceCenterOpeningHours.defaultOpeningHours = parseTimeFromAndTo(
      configServiceConfig.headers[0].hotline.openingHours.from,
      configServiceConfig.headers[0].hotline.openingHours.to
    );
  }

  // we simply boil potential multiple special opening hours down to one array
  // as there should only exist one config at max anyway
  serviceCenterOpeningHours.specialOpeningHours =
    configServiceConfig?.headers[0]?.hotline?.specials?.flatMap((special) => {
      if (special != null && 'items' in special) {
        return special.items.map((item) => {
          return {
            ...parseTimeFromAndTo(item.from, item.to),
            date: item.date,
          };
        });
      }
      return [];
    }) ?? [];

  return serviceCenterOpeningHours;
};
